var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{attrs:{"type":'workers',"subType":'no_id',"rowData":_vm.workers,"loadingMessage":_vm.loadingMessage,"noRowsMessage":_vm.noRowsMessage,"columns":_vm.columns,"paginationSize":50}})
}
var staticRenderFns = []

export { render, staticRenderFns }